module.exports = __webpack_public_path__ + "img/1F6BC.fc8e9806.svg";